import { render, staticRenderFns } from "./AudioElement.vue?vue&type=template&id=656845dc&scoped=true&"
import script from "./AudioElement.vue?vue&type=script&lang=ts&"
export * from "./AudioElement.vue?vue&type=script&lang=ts&"
import style0 from "./AudioElement.vue?vue&type=style&index=0&id=656845dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656845dc",
  null
  
)

export default component.exports